// tslint:disable:max-line-length
import { createAction, props } from '@ngrx/store';
import { PagedOverview } from 'src/app/core/models';
import { Initiative, InitiativeData, UpdateInitiativeData } from '../../models';

export const LoadMyInitiatives = createAction('[Initiatives] Load My Initiatives');
export const LoadMyInitiativesSuccess = createAction('[Initiatives] Load My Initiatives Success', props<{ initiatives: Initiative[] }>());
export const LoadMyInitiativesFail = createAction('[Initiatives] Load My Initiatives Fail', props<{ error: any }>());
